const useFetch = async ({ url, config }) => {
  try {
    console.log(config);
    const response = await fetch(url, config);
    const data = await response.json();
    console.log(data);
    if (response.status !== 200 && response.status !== 204) throw data;
    // if (!response.ok) throw data;
    return [true, { blob: false, json: data }];
  } catch (e) {
    return [false, { blob: false, json: e }];
  }
};

export default useFetch;
